'use client';

import dynamic from 'next/dynamic';
import { FormServer } from './form-server';

export default function FormWrapper({ title, consent }: { consent: string; title: string }) {
  const FormClient = dynamic(() => import('./form-client'), {
    ssr: false,
    loading: () => <FormServer title={title} consent={consent} />,
  });

  return <FormClient title={title} consent={consent} />;
}
